import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProductsById } from "../../actions/productActions";
import { seeSubWineries, listSubWineriesById, clearSubWineries } from "../../actions/subWineryActions";
import Winery from "../../containers/Wineries/Winery/Winery";

const ProductsListById = ({ match, history }) => {
  const dispatch = useDispatch();
  let Id = match.params.ProductsById;//ID from winery,subwinery or warehouse
  const { productsList } = useSelector((state) => state.productsList);
  const { subWineriesList } = useSelector((state) => state.subWineries)
  const [codeName, setCodeName] = useState('')

  useEffect(() => {
    if (subWineriesList.length != 0) {
      dispatch(seeSubWineries(codeName));
    }
  }, [codeName]);

  useEffect(() => {

    dispatch(listSubWineriesById(Id));
    return () => { dispatch(clearSubWineries()) }
  }, [Id]);



  return (
    <div>
      <Winery
        codeName={codeName}
        setCodeName={setCodeName}
        id={match.params.ProductsById}
        listProducts={subWineriesList}
        hadleClick={(data) => history.push('/Admin/Inventory/BatchesList/' + data + '/' + Id)}
      />
    </div>
  );
};

export default ProductsListById;
